import { render, staticRenderFns } from "./TransparenciaDecretosView.vue?vue&type=template&id=67b450d8&"
import script from "./TransparenciaDecretosView.vue?vue&type=script&lang=ts&"
export * from "./TransparenciaDecretosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports